export const CODEGUARD_PRODUCT_ID = {
  br: 235,
};
